<template>
  <div id="app" class="app">
    <router-view/>
  </div>
</template>

<script>
  import '../static/iconfont/iconfont.css'
export default {
  name: "App"
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #666666;
  font-size: 14px;
  /* margin-top: 60px; */
}
*{
  font-family: "Microsoft YaHei"
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}
a {
  text-decoration: none;
  color: #333;
}
button {
  border: none;
  outline: none;
  cursor: pointer;
}
select,
input {
  outline: none;
}
a:visited {
  color: #333;
}

.agent-right-title a {
  color: #333;
}

.agent-right-title a:hover {
  color: #0078ff;
}
.right-fixed{
  position:fixed;
  right:0;
  top:194px;
  z-index:9999;
}
img{
  border:none;
}
i{
  font-style:normal;
}
</style>



// WEBPACK FOOTER //
// src/App.vue